export var Theme;
(function (Theme) {
    Theme["COLLECTION"] = "collection";
    Theme["REGULAR"] = "regular";
})(Theme || (Theme = {}));
